module.exports = __webpack_public_path__ + "static/media/Flow-CreditCard-(non)3DS.532106b0.png";